import * as yup from 'yup';

// Lifted this from https://stackoverflow.com/questions/32044846/regex-for-iso-8601-durations
export const durationRegExp =
  /^P(?!$)((\d+Y)|(\d+\.\d+Y$))?((\d+M)|(\d+\.\d+M$))?((\d+W)|(\d+\.\d+W$))?((\d+D)|(\d+\.\d+D$))?(T(?=\d)((\d+H)|(\d+\.\d+H$))?((\d+M)|(\d+\.\d+M$))?(\d+(\.\d+)?S)?)??$/;

export const inspectionTemplateSchema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
  inspectionType: yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required()
  }),
  appManaged: yup.boolean(),
  inspectionInterval: yup.string().matches(durationRegExp).required(),
  reminderInterval: yup.string().matches(durationRegExp).required(),
  handler: yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required()
  })
});
